import React, { FC, useEffect, useRef, useState } from 'react';
import { Card, Box, Grid, Stack, Typography, Modal, Divider, Button } from '@mui/material';
import Container from '@mui/material/Container';
import "../../index.css"
import { Link as RouterLink } from 'react-router-dom';
import SigninForm from './SigninForm';
import HeroLoginForm from './HeroLoginForm';
import HomeHeader from './HomeHeader';
import './css/mobileStyle.css';
import HeroIllustration from '../../assets/hero.png';

// import loginImage from '../.././login-image.png';


import BgImg0 from './images/bg-registration-form-2.jpg';
import BgImg from './images/header/banner-bg.svg';
import BgImg2 from './images/bg2.png';
import Img0 from './images/icon.png';
import Img001 from './images/wareozo-full-white.png';
import Img1 from './images/wareozo-light.png';
// import Img01 from './images/wareozo.png';
import Img01 from './images/wareozo-half-black.png';
import Img2 from './images/header/header-hero-wareozo.png';
import Img8 from './images/services/services-shape.svg';
import Img9 from './images/services/services-shape-1.svg';
import Img10 from './images/services/services-shape-2.svg';
import Img11 from './images/services/services-shape-3.svg';
import Img12 from './images/about/about1.svg';
import Img13 from './images/about/about-shape-1.svg';
import Img14 from './images/about/about-shape-2.svg';
import Img15 from './images/about/about2.svg';
import Img16 from './images/about/about3.svg';
import Img17 from './images/video/video.png';
import Img18 from './images/video/dots.svg';
import Img19 from './images/a4-print-1.webp';
import Img20 from './images/imgs.webp';
import PrintImg1 from '../../assets/invoice-template-1.png';
import PrintImg2 from '../../assets/invoice-template-2.png';
import PrintImg3 from '../../assets/invoice-template-3.png';
import PrintImg4 from '../../assets/invoice-template-4.png';
import PrintImg5 from '../../assets/invoice-template-5.png';
import PrintImg6 from '../../assets/invoice-template-6.png';
import PrintImg7 from '../../assets/invoice-template-7.png';
import DashImg1 from '../../assets/feature-dashboard-1.png';
import DashImg2 from '../../assets/feature-dashboard-2.png';
import DashImg3 from '../../assets/feature-dashboard-3.png';
import DashImg4 from '../../assets/feature-dashboard-4.png';
import DashImg5 from '../../assets/feature-dashboard-5.png';
import DashImg6 from '../../assets/feature-dashboard-6.png';
import GstImg from '../../assets/gst.png';
import AboutImg from '../../assets/about.png';
import WalletImg from '../../assets/walket.png';
import PcImg from '../../assets/pc.png';
import ForgetImg from '../../assets/forget.png';
// import { Helmet } from "react-helmet";
import SignUpForm from '../SignUp/SignUpForm';
import ForgotPassword from '../ForgotPassword/ForgotPassword';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCrown, faTrophy, faStar } from '@fortawesome/free-solid-svg-icons';

/**
 * Sign In form Component. 
 */
// export function AddLibrary(urlOfTheLibrary:string) {
//   const script = document.createElement("script");
//   script.src = urlOfTheLibrary;
//   script.async = true;
//   document.body.appendChild(script);
// }



const SignIn: FC = () => {

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('0');
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);

  const [selected, setSelected] = useState('Thermal Prints');

  const options = ['Thermal Prints', 'A4 Prints', 'A5 Prints'];
  const options2 = ['Billing', 'Inventory Management', 'Business Management', 'Bonus Features'];
  const options3 = [
    { label: 'GSTR Filing', icon: <ReceiptLongOutlinedIcon /> }, // Replace with your actual icons
    { label: 'E-Invoicing', icon: <ReceiptLongOutlinedIcon /> },
    { label: 'E-way Billing', icon: <LocalShippingOutlinedIcon /> },
    { label: 'Data Export to Tally', icon: <LocalShippingOutlinedIcon /> },
  ];
  const factsFeatures = [
    {
      icon: <FactCheckOutlinedIcon />,
      title: 'Easy Billing',
      desc: 'Create professional invoices in just a few clicks.',
    },
    {
      icon: <SettingsOutlinedIcon />,
      title: 'Automation',
      desc: 'Automate recurring tasks and save valuable time.',
    },
    {
      icon: <TrendingUpOutlinedIcon />,
      title: 'Secure & Reliable',
      desc: 'Your data is safe with enterprise-grade security.',
    },
  ];

  const accordionData = [ 
    { title: 'What is billing software?', content: 'Billing software is a digital solution designed to automate and simplify business invoicing and billing processes. Also known as GST invoicing software, it is available in both on-premise and cloud-based versions. Key features typically include invoice generation, inventory and godown management, payment tracking, e-invoicing, e-way billing, and report generation. By using billing software, businesses can save time, minimize errors, and enhance overall efficiency in their financial operations.' },
    { title: 'What are the key features of billing software?', content: 'A good billing software includes:  Invoice generation (GST & non-GST). Inventory and stock management. Payment tracking & reminders. E-invoicing & e-way billing. Reports & analytics. Multi-user and multi-device support. ' },
    { title: 'What is an invoice?', content: 'An invoice is a document issued by a seller to a buyer, detailing the products or services provided along with their prices, applicable taxes, and payment terms. It serves as a formal request for payment.' },
    { title: 'Can I generate GST invoices using billing software?', content: 'Yes, most billing software allows you to create GST-compliant invoices with automatic tax calculations, helping businesses comply with government regulations.' },
    { title: 'Can I customize invoices in billing software?', content: 'Yes, most billing software allows you to customize invoice templates, add company logos, change color themes, and include additional fields based on your business requirements.' },
    { title: 'Is billing software available for mobile devices?', content: 'Yes, many billing solutions provide mobile apps for Android and iOS, allowing businesses to manage invoices, track payments, and monitor sales on the go.' },
    { title: 'How does billing software help in inventory management?', content: 'Billing software with inventory management features allows businesses to: \n Track stock levels in real-time. \n Get low-stock alerts. \n Manage multiple godowns/warehouses. \n Generate stock reports for better decision-making.' },
    { title: 'How do I get started with billing software?', content: 'You can start using billing software by: \n Signing up for a free trial or downloading the app. \n Adding your business details and setting up invoice templates. \n Configuring tax settings (GST/non-GST). \n Importing product and customer details. \n Generating your first invoice' },
    // { title: 'sadgsagsdgsdg?', content: 'somecontent' },
    // { title: 'sadgsagsdgsdg?', content: 'somecontent' },
  ];

  const Accordion = ({ title, content, index }: any) => {
    const isOpen = openAccordion === index;

    const toggleAccordion = () => {
      setOpenAccordion(isOpen ? null : index);
    };

    return (
      <div style={styles.accordionContainer}>
        <div
          onClick={toggleAccordion}
          style={styles.accordionHeader}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f8f9fa';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#fff';
          }}
        >
          <h3 style={{ ...styles.title, fontWeight: isOpen ? '600' : 'normal', color: isOpen ? '#059669' : '#333' }} >{title}</h3>
          <div style={{ color: isOpen ? '#059669' : '#666', transition: 'transform 0.3s ease, color 0.3s ease', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
            <KeyboardArrowDownRoundedIcon />
          </div>
        </div>
        <div
          style={{
            ...styles.accordionContent,
            maxHeight: isOpen ? '1000px' : '0px',
            overflow: 'hidden',
            transition: 'max-height 0.4s ease-in-out, padding 0.4s ease-in-out, opacity 0.3s ease-in-out',
            padding: isOpen ? (isMobile ? '16px 12px' : '20px 16px') : '0px 16px',
            opacity: isOpen ? 1 : 0
          }}
        >
          <p style={styles.contentText}>{content}</p>
        </div>
      </div>
    );
  };


  const navRef = useRef<any>()

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  const isMobile = width <= 768;

  useEffect(() => {
    import('./css/animate.css');
    import('./css/glightbox.min.css');
    import('./css/lineicons.css');
    import('./css/bootstrap.min.css');
    import('./css/style.css');
    import('./css2/style.css');
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      if (menu) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    }

    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [menu, isMobile]);

  useEffect(() => {
    const handleScroll = () => {
      const { offsetTop } = navRef.current
      if (window.pageYOffset > offsetTop) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, []);
  const isTablet = width > 768 && width <= 1024;
  const isDesktop = width > 1024;

  const styles = {
    accordionWrapper: {
      maxWidth: isMobile ? '100%' : '600px',
      margin: '0 auto',
      padding: isMobile ? '10px' : '20px',
    },
    accordionContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      marginBottom: '12px',
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
      overflow: 'hidden',
    },
    accordionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: isMobile ? '16px 12px' : '20px 16px',
      cursor: 'pointer',
      backgroundColor: '#fff',
      transition: 'background-color 0.2s ease',
      borderBottom: 'none',
    },
    title: {
      margin: 0,
      fontSize: isMobile ? '16px' : '18px',
      fontWeight: 'bold',
      color: '#333',
    },
    arrowIcon: {
      fontSize: '14px',
      color: '#333',
    },
    accordionContent: {
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #e9ecef',
    },
    contentText: {
      margin: 0,
      fontSize: isMobile ? '16px' : '18px',
      color: '#000',
    },
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1200);
  }, [])
  return (
    <>

      {loading && <div className="preloader">
        <div className="loader">
          <div className="spinner">
            <div className="spinner-container">
              <div className="spinner-rotator">
                <div className="spinner-left">
                  <div className="spinner-circle"></div>
                </div>
                <div className="spinner-right">
                  <div className="spinner-circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

      <header className="header-area" style={{ marginTop: '-64px' }}>
        <div ref={navRef} className={`navbar-area ${scrolled && 'sticky'}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className={`navbar navbar-expand-lg ${menu && isMobile ? 'menu-active' : ''}`}>
                  <a className="navbar-brand" href="#home">
                    <img src={scrolled ? Img01 : Img001} alt="Wareozo Billing Software" style={{ width: isMobile ? scrolled ? 100 : 120 : scrolled ? 180 : 150 }} />
                  </a>
                  <button
                    className={`navbar-toggler ${menu && 'active'}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => setMenu(!menu)}
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div
                    className={`collapse navbar-collapse sub-menu-bar ${menu && 'show'}`}
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="#home">Home</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="#features">Features</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="#pricing">Pricing</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="#about">About</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="#facts">Why</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a href="#faq">FAQ</a>
                      </li>
                    </ul>
                  </div>

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      style={{ backgroundColor: scrolled ? '#059669' : '#fff', color: scrolled ? '#fff' : '#059669', border: '2px solid #059669', textDecoration: 'none' }}
                      data-scroll-nav="0"
                      onClick={() => setOpen(!open)}
                      rel="nofollow" >
                      Login Now
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          id="home"
          className="header-hero"
          style={{ background: 'linear-gradient(135deg, #059669 0%, #047857 100%)', position: 'relative', overflow: 'hidden' }}
        >
          {!isMobile && (
            <img
              src={HeroIllustration}
              alt="hero illustration"
              style={{
                position: 'absolute',
                left: 0,
                bottom: 0,
                height: 'auto',
                width: 220,
                zIndex: 1,
                pointerEvents: 'none',
              }}
            />
          )}
          <div id="home" className="container" style={{ position: 'relative', zIndex: 2, paddingBottom: isMobile ? 40 : 40 }}>
            <div className="row align-items-center" style={{ paddingTop: isMobile ? 100 : 130 }}>
              <div className="col-lg-7" style={{ paddingBottom: isMobile ? 20 : 40 }}>
                <div className={`header-hero-content ${isMobile ? 'text-center' : ''}`} style={{ position: 'relative', zIndex: 3, paddingTop: 0, maxWidth: isMobile ? '100%' : 520, marginLeft: isMobile ? 0 : 70 }}>
                  {/* <h3
                    className="header-sub-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    Welcome to Wareozo
                  </h3> */}
                  <h2
                    className="header-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                    style={{ marginTop: 16, fontSize: isMobile ? 30 : 48, lineHeight: 1.2 }}
                  >
                    Transform Your Business <br />with Seamless <span style={{ color: '#66F57D' }}>Billing Solutions</span>
                  </h2>
                  <p
                    className="text wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.8s"
                  >
                    Boost your business with Wareozo Billing Software, a highly versatile platform for creating fully customizable invoices. Whether for GST or tax-exempt invoicing, our tools help you seamlessly showcase your brand’s identity.
                  </p>
                  <Button onClick={() => setOpen(!open)} style={{ marginTop: 30, backgroundColor: '#fff', borderRadius: 30, color: '#059669', padding: '10px 20px', fontSize: 18 }}>
                    Try Now <ArrowForwardRoundedIcon style={{ marginLeft: 10 }} />
                  </Button>
                </div>
              </div>
              <div className="col-lg-5" style={{ paddingBottom: 40, position: 'relative', zIndex: 10 }}>
                <div
                  className="wow fadeInUp"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.5s"
                  style={{
                    background: '#fff',
                    borderRadius: 6,
                    padding: isMobile ? '28px 24px' : '36px 40px',
                    border: '1px solid #e5e7eb',
                    maxWidth: 560,
                    marginLeft: 'auto',
                    marginRight: isMobile ? 'auto' : 0,
                    position: 'relative',
                    zIndex: 12,
                  }}
                >
                  <HeroLoginForm setType={setType} onOpenModal={() => setOpen(true)} />
                </div>
              </div>
            </div>
          </div>
          <div id="particles-1" className="particles"></div>
        </div>

      </header>



      <div className="container mt-5 pt-5">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div >
              <h1
                className="header-title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.5s"
              >
                Tailor Your Bills, Define Your Brand
              </h1>
              <p
                className="text mt-2 wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.8s"
                style={{ fontSize: 18 }}
              >
                Empower your business with customized invoicing solutions that reflect your unique brand identity. From logos to color schemes, create invoices that not only streamline your billing process but also leave a lasting impression on your clients. With every bill, showcase your professionalism and reinforce your brand’s presence.
              </p>
              <div className={`radio-group mt-4 ${isMobile ? 'w-100' : ''}`} style={{ width: isMobile ? '100%' : 500 }}>
                {options.map((option) => (
                  <div
                    key={option}
                    className={`radio-option ${selected === option ? 'selected' : ''}`}
                    onClick={() => setSelected(option)}
                  >
                    {option}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='section-1'>
        <div className='carousel-container'>
          <img src={PrintImg1} className='paper-scroll' alt="Invoice Template 1" />
          <img src={PrintImg2} className='paper-scroll' alt="Invoice Template 2" />
          <img src={PrintImg3} className='paper-scroll' alt="Invoice Template 3" />
          <img src={PrintImg4} className='paper-scroll' alt="Invoice Template 4" />
          <img src={PrintImg5} className='paper-scroll' alt="Invoice Template 5" />
          <img src={PrintImg6} className='paper-scroll' alt="Invoice Template 6" />
          <img src={PrintImg7} className='paper-scroll' alt="Invoice Template 7" />
          {/* Duplicate images for infinite scroll effect */}
          <img src={PrintImg1} className='paper-scroll' alt="Invoice Template 1" />
          <img src={PrintImg2} className='paper-scroll' alt="Invoice Template 2" />
          <img src={PrintImg3} className='paper-scroll' alt="Invoice Template 3" />
          <img src={PrintImg4} className='paper-scroll' alt="Invoice Template 4" />
          <img src={PrintImg5} className='paper-scroll' alt="Invoice Template 5" />
          <img src={PrintImg6} className='paper-scroll' alt="Invoice Template 6" />
          <img src={PrintImg7} className='paper-scroll' alt="Invoice Template 7" />
        </div>
      </div>

      <div id="features" className="container mt-5 pt-5">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div >
              <h1
                className="header-title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.5s"
              >
                Powerful Billing Software to Accelerate Your Business Growth by 10x
              </h1>
              <div className="radio-group mt-5" >
                {options2.map((option) => (
                  <div
                    key={option}
                    className={`radio-option ${selected === option ? 'selected' : ''}`}
                    onClick={() => setSelected(option)}
                  >
                    {option}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="row" style={{ padding: isMobile ? '20px 10px' : '50px 100px' }}>
            <div className="col-lg-4">
              <div className='card-grid feature-card'>
                <img src={DashImg1} />
                <Divider />
                <p className='p-2'>Multiple Bank Account</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className='card-grid feature-card'>
                <img src={DashImg2} />
                <Divider />
                <p className='p-2'>Multiple Bank Account</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className='card-grid feature-card'>
                <img src={DashImg3} />
                <Divider />
                <p className='p-2'>Multiple Bank Account</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className='card-grid feature-card'>
                <img src={DashImg4} />
                <Divider />
                <p className='p-2'>Multiple Bank Account</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className='card-grid feature-card'>
                <img src={DashImg5} />
                <Divider />
                <p className='p-2'>Multiple Bank Account</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className='card-grid feature-card'>
                <img src={DashImg6} />
                <Divider />
                <p className='p-2'>Multiple Bank Account</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="container mt-5 pt-5">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div >
              <h1
                className="header-title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.5s"
              >
                Simplify GST Compliance with Wareozo Smart Invoicing Software
              </h1>
            </div>
          </div>
          <div style={{ padding: isMobile ? '20px 10px' : '50px 100px' }} className='row' >
            <div className={isMobile ? "col-12" : "col-lg-4"}>
              <div className="radio-list">
                {options3.map((option, index) => (
                  <div
                    key={index}
                    className={`radio-item ${selected === option.label ? 'selected' : ''}`}
                    onClick={() => setSelected(option.label)}
                  >
                    <div className="icon">{option.icon}</div>
                    <span style={{ fontSize: isMobile ? 18 : 20, fontWeight: 400 }}>{option.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className={isMobile ? "col-12 mt-4" : "col-lg-8"}>
              <div className='card-grid'>
                <img src={GstImg} style={{ width: '100%', borderRadius: '10px 10px 0 0' }} />
                <Divider />
                <p className='p-3' style={{ fontSize: isMobile ? 16 : 18 }}>Export your GSTR1 data in a simple format (JSON) and easily file your GST returns. Also, get GSTR-2 and GSTR-3B reports that would help you/your CAs in easy GST tax filing.</p>
                <Button style={{ margin: '20px 15px', backgroundColor: '#059669', borderRadius: 30, color: '#fff', padding: isMobile ? '8px 16px' : '10px 20px', fontSize: isMobile ? 16 : 18 }}>
                  Get Started Now <ArrowForwardRoundedIcon style={{ marginLeft: 10 }} />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="faq" className="container mt-5 pt-5">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div >
              <h1
                className="header-title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.5s"
              >
                Frequently Asked Questions
              </h1>
              <p
                className="text mt-2 wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.8s"
                style={{ fontSize: 18 }}
              >
                Find quick answers to all your questions about billing software, top billing solutions in India, GST invoicing, e-invoicing, e-way billing, and comprehensive GST billing software.
              </p>
            </div>
          </div>
          <div style={{ padding: isMobile ? '20px 15px' : '50px 115px' }}>
            {accordionData.map((item, index) => (
              <Accordion key={index} index={index} title={item.title} content={item.content} />
            ))}
          </div>
        </div>
      </div>

      <div id="pricing" className="container mt-5 pt-5">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div >
              <h1
                className="header-title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.5s"
              >Pricing
              </h1>
              <h3
                className="header-title wow fadeInUp mt-3" style={{ fontWeight: 'normal' }}
                data-wow-duration="1.3s"
                data-wow-delay="0.5s"
              >
                All plans with
                7 days money back guarantee
              </h3>
            </div>
          </div>
          <div style={{ padding: isMobile ? '0px 15px' : '0px 115px' }} className={`pricing-container ${isMobile ? 'mobile-pricing' : ''}`}>
            <div className="plan diamond">
              <div className="plan-header">
                <FontAwesomeIcon icon={faCrown} className="plan-icon" />
                <h3 className="plan-title">Basic</h3>

              </div>
              <p className="plan-price">₹200/month</p>
              <p className="plan-annual">Pay ₹2399/year. Billed annually</p>
              <button className="plan-button">Start Free Trial</button>
              <ul className="plan-features">
                <li><FontAwesomeIcon icon={faCheck} /> Manage 1 Business</li>
                <li><FontAwesomeIcon icon={faCheck} /> Access for 1 User + 1 CA</li>
                <li><FontAwesomeIcon icon={faCheck} /> Auto sync data across unlimited devices</li>
                <li><FontAwesomeIcon icon={faCheck} /> Access on Android & Web</li>
                <li><FontAwesomeIcon icon={faCheck} /> Generate, print (A4 printer )</li>
                <li><FontAwesomeIcon icon={faCheck} /> Manage 1 Employee </li>
              </ul>
              <p className="includes-title" style={{ textAlign: 'left' }}>Buy Addon Features</p>
              <ul className="includes-features">
                <li>Custom Invoice Templates</li>
                <li>Support 9*5</li>
                <li>Thermal Printer </li>
              </ul>
            </div>

            <div className="plan platinum">
              <div className="plan-header">
                <FontAwesomeIcon icon={faTrophy} className="plan-icon" />
                <h3 className="plan-title">Standard</h3>
                <span className="most-popular">Most Popular</span>

              </div>
              <p className="plan-price">₹250/month</p>
              <p className="plan-annual">Pay ₹2999/year. Billed annually</p>
              <button className="plan-button">Start Free Trial</button>
              <button className="plan-button secondary">Talk to Sales</button>
              <ul className="plan-features">
                <li><FontAwesomeIcon icon={faCheck} /> Manage 3 Businesses</li>
                <li><FontAwesomeIcon icon={faCheck} /> Access for 4 Users + 1 CA</li>
                <li><FontAwesomeIcon icon={faCheck} /> Auto sync data across unlimited devices</li>
                <li><FontAwesomeIcon icon={faCheck} /> Access on Android, Web </li>
                <li><FontAwesomeIcon icon={faCheck} /> Generate, print (A4 printer, A3 Print, Thermal Printer )</li>
                <li><FontAwesomeIcon icon={faCheck} /> Manage 5 Employees </li>
              </ul>
              <p className="includes-title" style={{ textAlign: 'left' }} >Includes Basic, plus:</p>
              <ul className="includes-features">
                <li>Unlimited Godowns</li>
                <li>Bulk Invoice Download & Printing</li>
                <li>Print Barcodes with label printer support</li>
                <li>WhatsApp Marketing </li>
                <li>SMS Marketing (600 SMS/year) </li>
                <li>E-Way Bill Generation (50/year)</li>
                <li>Employee Attendance & Payroll management </li>
              </ul>
            </div>

            <div className="plan enterprise">
              <div className="plan-header">
                <FontAwesomeIcon icon={faCrown} className="plan-icon" />
                <h3 className="plan-title">Enterprise</h3>

              </div>
              <p className="plan-price"><br /></p>
              <p className="plan-annual"><br /></p>
              <button className="plan-button secondary">Talk to Sales</button>
              <ul className="plan-features">
                <li><FontAwesomeIcon icon={faCheck} /> Manage upto 3 Businesses (Upgrade to add more)</li>
                <li><FontAwesomeIcon icon={faCheck} /> Access for upto 5 Users (Upgrade to add more) + 1 CA</li>
                <li><FontAwesomeIcon icon={faCheck} /> Auto sync data across unlimited devices</li>
                <li><FontAwesomeIcon icon={faCheck} /> Access on Android, Web </li>
              </ul>
              <p className="includes-title" style={{ textAlign: 'left' }} >Includes Standard, plus:</p>
              <ul className="includes-features">
                <li>Unlimited E-Way Bill Generation</li>
                <li>Automated Recurring Billing</li>
                <li>Seamless E-Invoicing</li>
                <li>Loyalty & Rewards Engine</li>
                <li>User Insights & Activity Logs</li>
                <li>Tally Sync on Demand</li>
              </ul>
            </div>
          </div>
        </div>
      </div>



      <section className="services-area pt-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="section-title text-center pb-40">
                <div className="line m-auto"></div>
                <h3 className="title">
                  Powerful Billing Software to Simplify Your Business
                  <span> Comes with everything you need to get started!</span>
                </h3>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-7 col-sm-8">
              <div
                className="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                <div className="services-icon">
                  <img
                    className="shape"
                    src={Img8}
                    alt="shape"
                  />
                  <img
                    className="shape-1"
                    src={Img9}
                    alt="shape"
                  />
                  <i className="lni lni-baloon"> </i>
                </div>
                <div className="services-content mt-30">
                  <h4 className="services-title">
                    <a href="javascript:void(0)">Clean</a>
                  </h4>
                  <p className="text">
                    Experience a clutter-free, intuitive interface that simplifies invoicing and billing for smooth and effortless management.
                  </p>
                  {/* <a className="more" href="javascript:void(0)"
                  >Learn More <i className="lni lni-chevron-right"> </i>
                  </a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-7 col-sm-8">
              <div
                className="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div className="services-icon">
                  <img
                    className="shape"
                    src={Img8}
                    alt="shape"
                  />
                  <img
                    className="shape-1"
                    src={Img10}
                    alt="shape"
                  />
                  <i className="lni lni-cog"> </i>
                </div>
                <div className="services-content mt-30">
                  <h4 className="services-title">
                    <a href="javascript:void(0)">Robust</a>
                  </h4>
                  <p className="text">
                    Built for stability and efficiency, our software ensures secure, high-performance billing with seamless data handling.
                  </p>
                  {/* <a className="more" href="javascript:void(0)"
                  >Learn More <i className="lni lni-chevron-right"> </i>
                  </a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-7 col-sm-8">
              <div
                className="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.8s"
              >
                <div className="services-icon">
                  <img
                    className="shape"
                    src={Img8}
                    alt="shape"
                  />
                  <img
                    className="shape-1"
                    src={Img11}
                    alt="shape"
                  />
                  <i className="lni lni-bolt-alt"> </i>
                </div>
                <div className="services-content mt-30">
                  <h4 className="services-title">
                    <a href="javascript:void(0)">Powerful & Feature-Rich</a>
                  </h4>
                  <p className="text">
                    Streamline billing with a powerful, fast, and secure solution for invoicing, inventory, and seamless financial tracking.
                  </p>
                  {/* <a className="more" href="javascript:void(0)"
                  >Learn More <i className="lni lni-chevron-right"> </i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

        </div>

      </section>

      <section id="about">
        <div className="about-area pt-70">

          <div className="about-shape-1">
            <img src={Img13} alt="shape" />
          </div>
        </div>

        <div className="about-area pt-70">
          <div className="about-shape-2">
            <img src={Img14} alt="shape" />
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 order-lg-last">
                <div
                  className="about-content ms-lg-auto mt-50 wow fadeInLeftBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <div className="section-title">
                    <div className="line"></div>
                    <h3 className="title">
                      About Us - Wareozo
                    </h3>
                  </div>

                  <p className="text">
                    Wareozo is a powerful billing software designed to streamline invoicing, automate accounting, and enhance business efficiency. Whether you're a small business, retailer, or enterprise, Wareozo simplifies GST & non-GST invoicing, inventory management, and payment tracking. With cloud-based access, multi-device support, and secure data handling, we help businesses save time, reduce errors, and boost growth. Experience smart, seamless, and hassle-free billing with Wareozo!
                  </p>
                  <Button style={{ margin: '20px 0px', backgroundColor: '#059669', borderRadius: 30, color: '#fff', padding: '10px 20px', fontSize: 18 }}>
                    Try it Free <ArrowForwardRoundedIcon style={{ marginLeft: 10 }} />
                  </Button>
                </div>

              </div>
              <div className="col-lg-6 order-lg-first">
                <div
                  className="about-image text-center mt-50 wow fadeInRightBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <img src={AboutImg} alt="about" style={{ width: '100%', borderRadius: 10 }} />
                </div>

              </div>
            </div>

          </div>

        </div>

        <div className="about-area pt-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className="about-content mt-50 wow fadeInLeftBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <div className="section-title">
                    <div className="line"></div>
                    <h3 className="title">
                      <span>Wareozo</span> Smart Billing for Businesses
                    </h3>
                  </div>

                  <p className="text">
                    Effortless invoicing, automated accounting, and seamless payment tracking—Wareozo is the ultimate billing software designed for businesses of all sizes. Generate GST & non-GST invoices, manage inventory, and streamline transactions with a secure, cloud-based solution. Whether you're a startup, retailer, or enterprise, Wareozo simplifies financial operations and helps your business grow. Experience faster, smarter, and more efficient billing today!
                  </p>
                  <Button style={{ margin: '20px 0px', backgroundColor: '#059669', borderRadius: 30, color: '#fff', padding: '10px 20px', fontSize: 18 }}>
                    Try it Free <ArrowForwardRoundedIcon style={{ marginLeft: 10 }} />
                  </Button>
                </div>

              </div>
              <div className="col-lg-6">
                <div
                  className="about-image text-center mt-50 wow fadeInRightBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <img src={WalletImg} alt="about" style={{ width: '100%', borderRadius: 10 }} />
                </div>

              </div>
            </div>

          </div>

          <div className="about-shape-1">
            <img src={Img13} alt="shape" />
          </div>
        </div>
      </section>

      <section id="facts" className="video-counter" style={{ padding: isMobile ? '48px 0 58px' : '75px 0 85px', background: '#fff' }}>
        <div className="container" style={{ maxWidth: 1240 }}>
          <div className="row align-items-center" style={{ rowGap: isMobile ? 38 : 0 }}>
            <div className="col-lg-6">
              <div
                className="wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
                style={{
                  position: 'relative',
                  padding: isMobile ? '0 10px 26px 10px' : '8px 0 34px 28px',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: isMobile ? 0 : 0,
                    bottom: 0,
                    width: isMobile ? '58%' : '52%',
                    height: isMobile ? 112 : 160,
                    backgroundImage: 'radial-gradient(circle, rgba(5, 150, 105, 0.85) 1.5px, transparent 1.5px)',
                    backgroundSize: isMobile ? '14px 14px' : '14px 14px',
                    opacity: 0.8,
                    zIndex: 0,
                  }}
                />
                <img
                  src={PcImg}
                  alt="Wareozo Dashboard"
                  style={{
                    width: isMobile ? '100%' : '92%',
                    display: 'block',
                    borderRadius: 0,
                    position: 'relative',
                    zIndex: 1,
                    boxShadow: '0 10px 28px rgba(15, 23, 42, 0.12)',
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div
                className="counter-wrapper wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.8s"
                style={{
                  paddingLeft: isMobile ? 10 : 24,
                  paddingRight: isMobile ? 10 : 0,
                  marginTop: isMobile ? 0 : 0,
                }}
              >
                <div className="section-title">
                  <div className="line"></div>
                </div>
                <h3
                  className="title"
                  style={{
                    color: '#070c20',
                    fontSize: isMobile ? 26 : 32,
                    lineHeight: 1.3,
                    fontWeight: 700,
                    margin: 0,
                    letterSpacing: 0,
                  }}
                >
                  Effortless Invoicing, Smart Accounting & Business Growth
                </h3>
                <p
                  className="text"
                  style={{
                    color: '#5f6478',
                    fontSize: isMobile ? 15 : 16,
                    lineHeight: 1.75,
                    margin: isMobile ? '16px 0 28px' : '18px 0 34px',
                    maxWidth: 560,
                  }}
                >
                  Simplify invoicing, automate accounting, and accelerate business growth with smart solutions and efficient billing software.
                </p>

                <div className="row" style={{ rowGap: isMobile ? 28 : 0 }}>
                  {factsFeatures.map((item, i) => (
                    <div
                      className="col-12 col-sm-4"
                      key={item.title}
                      style={{
                        borderLeft: !isMobile && i > 0 ? '1px solid #dcdfe7' : 'none',
                      }}
                    >
                      <div
                        style={{
                          textAlign: 'center',
                          padding: isMobile ? '0 8px' : '0 26px',
                        }}
                      >
                        <div
                          style={{
                            width: isMobile ? 72 : 86,
                            height: isMobile ? 72 : 86,
                            borderRadius: '50%',
                            background: '#e8f4ed',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 18px',
                            color: '#087d3d',
                          }}
                        >
                          {React.cloneElement(item.icon, { sx: { fontSize: isMobile ? 34 : 40, strokeWidth: 1.4 } })}
                        </div>
                        <h4
                          style={{
                            color: '#090d1e',
                            fontSize: isMobile ? 16 : 17,
                            fontWeight: 700,
                            margin: '0 0 12px',
                            lineHeight: 1.25,
                          }}
                        >
                          {item.title}
                        </h4>
                        <p
                          style={{
                            color: '#676d82',
                            fontSize: isMobile ? 14 : 15,
                            lineHeight: 1.6,
                            margin: 0,
                          }}
                        >
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div
            className="subscribe-area wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title">
                    Stay Connected <span>subscribe to our communication channels</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mt-45" style={{ textAlign: 'right' }}>
                  <a href="/opt-in" style={{ textDecoration: 'none', padding: '12px 36px', borderRadius: '30px', backgroundColor: '#059669', color: '#fff', fontSize: '16px', fontWeight: 600, display: 'inline-block' }}>Subscribe Now</a>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div
                  className="footer-about mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.2s"
                >
                  <a className="logo" href="javascript:void(0)">
                    <img src={Img0} alt="Wareozo" style={{ width: 80 }} />
                    <img src={Img1} alt="Wareozo" />
                  </a>
                  <p className="text">
                    Simplify invoicing, automate accounting, and boost business growth with smart, secure, and efficient wareozo billing software.
                    {/* Elevate your business with Wareozo Billing Software, the most versatile platform for creating fully customizable invoices. */}
                  </p>
                  <ul className="social">
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-facebook-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-twitter-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-instagram-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-linkedin-original"> </i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-5 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.4s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Quick Link</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/terms-of-use">Terms of Service</a></li>
                      <li><a href="#pricing">Pricing</a></li>
                      <li><a href="#faq">FAQ</a></li>
                      <li><a href="/opt-out">Unsubscribe</a></li>
                    </ul>
                  </div>

                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.6s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Resources</h4>
                    </div>
                    <ul className="link">
                      <li><a href="#home">Home</a></li>
                      <li><a href="#features">Features</a></li>
                      <li><a href="#about">About</a></li>
                      <li><a href="#why">Why</a></li>
                      <li><a href="javascript:void(0)">Contact</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12">
                <div
                  className="footer-contact mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.8s"
                >
                  <div className="footer-title">
                    <h4 className="title">Contact Us</h4>
                  </div>
                  <ul className="contact">
                    <li>support@wareozo.com</li>
                    <li>www.wareozo.com</li>
                    <li>
                      121, Sai Nagar, Near HBL Tower, <br /> Nagpur, Maharashtra - 441108
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-between">
                  <div className="copyright-content">
                    <p className="text">
                      Designed and Developed by
                      <a href="javascript:void(0)" rel="nofollow" style={{ textDecoration: 'none' }}> &nbsp; Wareozo</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div id="particles-2"></div>
      </footer>

      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>

      <Modal open={open} onClose={(event: any, reason: any) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown")
          setOpen(false);
      }}>
        <div className='centerme'>
          <div
            className={`${isMobile ? 'maindiv2' : 'maindiv'}`}
            style={{
              position: 'relative',
              ...(type === '2' ? { background: '#fff' } : {}),
            }}
          >
            {/* Close button */}
            <button
              onClick={() => setOpen(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                zIndex: 1000,
                color: '#666',
                padding: '5px',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#666';
              }}
            >
              ×
            </button>

            <div style={{ width: isMobile ? '100%' : '50%' }}>
              {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType} /> : <ForgotPassword setType={setType} />}
            </div>
            {!isMobile && <div style={{ width: '50%', background: type === '2' ? '#fff' : 'transparent' }}>
              <img
                src={type === '2' ? ForgetImg : BgImg2}
                alt={type === '2' ? 'Forgot password illustration' : 'Account access illustration'}
              />
            </div>}
          </div>
        </div>
      </Modal>
      {/* <Helmet>
      <script src="js/bootstrap.bundle.min.js" type="text/javascript"></script>
    <script src="js/wow.min.js" type="text/javascript"></script>
    <script src="js/glightbox.min.js" type="text/javascript"></script>
    <script src="js/count-up.min.js" type="text/javascript"></script>
    <script src="js/particles.min.js" type="text/javascript"></script>
    <script src="js/main.js" type="text/javascript"></script>
      </Helmet> */}

      {/* {AddLibrary("./js/bootstrap.bundle.min.js")}
      {AddLibrary("./js/wow.min.js")}
      {AddLibrary("./js/glightbox.min.js")}
      {AddLibrary("./js/count-up.min.js")}
      {AddLibrary("./js/particles.min.js")}
      {AddLibrary("./js/main.js")} */}


    </>
  );
}

export default SignIn;

